import useApiService from "../utilities/useApiService";
import { QueryHandler } from "../network/models/QueryHandlers";
import { AxiosResponse } from "axios";
import { InfiniteListControls } from "./infiniteListTypes";
import { useInfiniteSearchList } from "./useInfiniteSearchList";

type UseManufacturersOptions = {
  pageSize?: number;
  debounceMs?: number;
  enabled?: boolean;
};

export const useManufacturers = (
   searchTermQuery = "",
   handlers?: QueryHandler<any | undefined, AxiosResponse<any>>,
  options: UseManufacturersOptions = {},
): [
  string[] | undefined,
   (searchTermQuery: string) => void,
  InfiniteListControls,
] => {
   const { getMethod } = useApiService();
  return useInfiniteSearchList<string>({
    searchTermQuery,
    queryKey: ["/items/manufacturers"],
    handlers,
    options,
    fetchPage: async ({ signal, pageParam, pageSize, debouncedSearchTerm }) => {
         const res = await getMethod("/items/manufacturers", {
            signal,
            params: { query: debouncedSearchTerm, page: pageParam, size: pageSize },
         });
         return res.data as string[];
      },
  });
};
